import { css } from '@emotion/react';

import {
  EuiLoadingElastic,
  EuiPanel,
  EuiSpacer,
  EuiText,
  useEuiTheme,
} from '@elastic/eui';

export const FullPageLoader = () => {
  const { euiTheme } = useEuiTheme();

  return (
    <EuiPanel
      color="subdued"
      hasShadow={false}
      hasBorder={false}
      css={css({
        position: 'fixed',
        inset: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: euiTheme.levels.toast,
      })}
    >
      <EuiText textAlign="center">
        <EuiLoadingElastic size="xxl" data-test-id="app-loading" />
        <EuiSpacer />
        <strong>Loading AutoOps...</strong>
      </EuiText>
    </EuiPanel>
  );
};
